<!-- select type radio -->
<div *ngIf="selectorType == 'radio' && group != null" class="wb-radio" [formGroup]="group">
  <mat-radio-group *ngIf="valuePassed" (change)="userChange($event);">
    <span *ngFor="let label of labels;let i = index">
      <mat-radio-button *ngIf="i == value" [value]="label" checked="true" [formControlName]="controlName">{{label}}</mat-radio-button>
      <mat-radio-button *ngIf="i != value" [value]="label" checked="false" [formControlName]="controlName">{{label}}</mat-radio-button>
    </span>
  </mat-radio-group>
  <mat-radio-group *ngIf="!valuePassed" (change)="userChange($event);">
    <mat-radio-button *ngFor="let label of labels" [value]="label" [formControlName]="controlName">{{label}}</mat-radio-button>
  </mat-radio-group>
</div>

<div *ngIf="selectorType == 'radio' && group == null" class="wb-radio">
  <mat-radio-group *ngIf="valuePassed" (change)="userChange($event);">
    <span *ngFor="let label of labels;let i = index">
      <mat-radio-button *ngIf="i == value" [value]="label" checked="true">{{label}}</mat-radio-button>
      <mat-radio-button *ngIf="i != value" [value]="label" checked="false">{{label}}</mat-radio-button>
    </span>
  </mat-radio-group>
  <mat-radio-group *ngIf="!valuePassed" (change)="userChange($event);">
    <mat-radio-button *ngFor="let label of labels" [value]="label">{{label}}</mat-radio-button>
  </mat-radio-group>
</div>

<!-- select type checkbox -->
<div *ngIf="selectorType == 'checkbox' && group != null" class="wb-checkbox" [formGroup]="group">
  <input [attr.aria-label]="labels[0]" type="checkbox" id="{{inputId}}_{{custGroupId}}" (change)="userChange($event);"  [formControlName]="controlName" [(ngModel)]="toggle">
  <label for="{{inputId}}_{{custGroupId}}">{{labels[value]}}</label>
</div>

<div *ngIf="selectorType == 'checkbox' && group == null" class="wb-checkbox"  [ngClass]="notRemovable ? 'wab-not-allowed' : ''">
  <input [attr.aria-label]="labels[0]" type="checkbox" id="{{inputId}}_{{custGroupId}}" (change)="userChange($event);" [attr.disabled]="notRemovable || (isMaxSelection && !toggle) ? true: null" [(ngModel)]="toggle">
  <label for="{{inputId}}_{{custGroupId}}">{{labels[value]}}</label>
</div>

<!-- select type stepper counter -->
<div *ngIf="selectorType == 'stepper' && group != null" class="wb-stepper" [ngClass]="{'active': value !== 0 || value !== undefined}" [formGroup]="group" >
  <div class="group-btn" >
    <div id="{{inputId}}_{{custGroupId}}_decrement" tabindex="0" role="button" type="button"     
    [attr.aria-disabled] = "isStepperDisabled('decrement')? 'true': 'false'"
    [attr.aria-label]="isStepperDisabled('decrement')? null: 'Decrease quantity'" class="stepper-btn decrement-btn" 
    [ngClass]="{'disabled': isStepperDisabled('decrement')}"
      (click)="userChange($event, 'decrement');">
      <span class="glyphicon glyphicon-minus"></span>
    </div>
  </div>
  <div class="group-input">
    <input tabindex="0" role="text" aria-label="quantity"  type="text" [min]="min" readonly ="readonly" [max]="max" class="form-control input-number" [(ngModel)]="labels[value]" maxlength="inputLength" [disabled]="value == undefined">
  </div>
  <div id="{{inputId}}_{{custGroupId}}_increment" class="group-btn" >
    <div tabindex="0" role="button" type="button" class="stepper-btn increment-btn" 
    [attr.aria-label]="isStepperDisabled('increment')? null: 'Increase quantity'"
    [attr.aria-disabled] = "isStepperDisabled('increment')? 'true': 'false'"
    [ngClass]="{'disabled': isStepperDisabled('increment')}"
       (click)="userChange($event, 'increment');">
      <span class="glyphicon glyphicon-plus"></span>
    </div>
  </div>
</div>

<div *ngIf="selectorType == 'stepper' && group == null" class="wb-stepper" [ngClass]="{'active': value !== 0 || value !== undefined}">
  <div class="group-btn">
    <div id="{{inputId}}_{{custGroupId}}_decrement" tabindex="0" role="button" type="button" 
    [attr.aria-disabled]= "isStepperDisabled('decrement')? 'true': 'false'"
    [attr.aria-label]="isStepperDisabled('decrement')? null: 'Decrease quantity'"  class="stepper-btn decrement-btn" 
    [ngClass]="{'disabled': isStepperDisabled('decrement')}" (click)="userChange($event, 'decrement');">
      <span class="glyphicon glyphicon-minus"></span>
    </div>
  </div>
  <div class="group-input">
    <input tabindex="0" role="text" aria-label="quantity" type="text" [min]="min" readonly ="readonly" [max]="max" class="form-control input-number" [(ngModel)]="labels[value]" maxlength="inputLength" [disabled]="value == undefined">
  </div>
  <div class="group-btn">
    <div id="{{inputId}}_{{custGroupId}}_increment" tabindex="0" type="button" 
    [attr.aria-disabled]= "isStepperDisabled('increment')? 'true': 'false'"
    [attr.aria-label]="isStepperDisabled('increment')? null: 'Increase quantity'"
    role="button" class="stepper-btn increment-btn" 
    [ngClass]="{'disabled': isStepperDisabled('increment')}" (click)="userChange($event, 'increment');">
      <span class="glyphicon glyphicon-plus"></span>
    </div>
  </div>
</div>

<!-- select type toggle switch -->
<div *ngIf="selectorType == 'toggle' && group != null" class="wb-switch" [formGroup]="group">
  <label class="switch">
    <input type="checkbox" [formControlName]="controlName" [(ngModel)]="toggle" id="toggle">
    <span class="slider round"></span>
    <label *ngIf="labelPassed" for="toggle">{{labels[value]}}</label>
  </label>
</div>

<div *ngIf="selectorType == 'toggle' && group == null" class="wb-switch">
  <label class="switch">
    <input type="checkbox" [(ngModel)]="toggle" id="toggle">
    <span class="slider round"></span>
    <label *ngIf="labelPassed" for="toggle">{{labels[value]}}</label>
  </label>
</div>

<!-- select type slider -->
<div *ngIf="selectorType == 'slider' && group != null" class="wb-slider" [formGroup]="group">
  <mat-slider [attr.aria-label]="labels[value]" [min]="min" [max]="max" [step]="step" [(ngModel)]="value" (change)="userChange($event)" [formControlName]="controlName" [disabled]="value == undefined"></mat-slider>
  <span>{{labels[value]}}</span>
</div>

<div *ngIf="selectorType == 'slider' && group == null" class="wb-slider">
  <mat-slider [attr.aria-label]="labels[value]" [min]="min" [max]="max" [step]="step" [(ngModel)]="value" (change)="userChange($event)" [disabled]="value==undefined" flex md-discrete ng-readonly="readonly"></mat-slider>
  <span>{{labels[value]}}</span>
</div>
